module.exports = __webpack_public_path__ + "static/media/PascalTriangleFibonacci.9f4bf367.svg";